import { ACTION_INPUT_STEP_TYPE } from "./action-interfaces";

/**
 * Step types that start a workflow run. A definition may contain several of
 * these; each one is an independent entry point. A run is started BY exactly
 * one of them (`triggerStepId` on the start params) — the others are pruned
 * for that run, along with everything reachable only from them.
 *
 * Kept as a plain string list (rather than derived from step configs) because
 * the Temporal workflow VM reads it and cannot see the runtime step registry.
 * `backend/tests/workflows/helpers/stepConfigs.test.ts` keeps it in parity
 * with the step configs' `category: "Trigger"`.
 */
export const TRIGGER_STEP_TYPES = [
  "event_trigger",
  "email_rule_trigger",
  "schedule_trigger",
  "http_trigger",
  "form_trigger",
  "observe_data_source_link",
  "watch_for_file_changes",
  ACTION_INPUT_STEP_TYPE,
] as const;

export type TriggerStepType = (typeof TRIGGER_STEP_TYPES)[number];

const TRIGGER_STEP_TYPE_SET: ReadonlySet<string> = new Set(TRIGGER_STEP_TYPES);

export function isTriggerStepType(
  stepType: string,
): stepType is TriggerStepType {
  return TRIGGER_STEP_TYPE_SET.has(stepType);
}
